import PlusMinusInput from "components/Form/PlusMinusInput/PlusMinusInput";
import { currencyFormat } from "helpers/functions";
import useAPI from "hooks/useAPI";
import styles from "./CheckoutTable.module.scss";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import DeleteDialog from "../../../components/Dialogs/DeleteDielog";
import { isPriceVisible, isPurchaseAllowed } from "../../../helpers/product";
import { useTranslation } from "react-i18next";

const ProductRow = ({ item, max, showImage = true }) => {
    const { t } = useTranslation();
    const location = useLocation();

    // Price display or purchase could be disabled for product after it was added to cart
    const price_visible = isPriceVisible(item?.product?.behaviours?.checkout);
    const can_purchase = isPurchaseAllowed(item?.product?.behaviours?.checkout);
    const formatPrice = (value, currency) => (price_visible ? currencyFormat(value, currency) : t("global-default-text-price_on_request", "Cena na upit"));

    const api = useAPI();
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    // Track the quantity to add to the cart
    const rabateCalc = (item) => {
        let rabate = [];
        item?.product?.price?.per_item?.rebate?.active &&
            item?.product?.price?.per_item?.rebate?.rebates?.map((rebate) => {
                rabate.push(rebate?.calc?.calc_name);
                return null;
            });
        return rabate.join("; ");
    };

    const [config, setConfig] = useState();
    useEffect(() => {
        if (typeof document !== "undefined") {
            const inventory_config = localStorage.getItem("configuration_inventories");
            if (inventory_config) {
                let temp = JSON.parse(inventory_config);
                temp = temp?.filter((item) => item?.slug === "check_requested_inventory_product_quantity");
                if (temp?.length > 0) {
                    setConfig(Boolean(Number(temp[0]?.value)));
                }
            }
        }
    }, []);

    const setQuantity = (quantity) => {
        api.globalAddToCart(item?.product?.basic_data?.id_product, quantity, loading, setLoading, loadingDelete, setLoadingDelete, null, "replace");
    };

    return (
        <>
            <tr className={`relative`} style={{ borderWidth: "5px", borderColor: "transparent", borderStyle: "solid" }}>
                {/*{showImage && <td className={styles.tcImage}>{item.product.image ? <img src={item.product.image} alt=""/> : "-"}</td>}*/}
                <td className={styles.tcCode}>{item?.product?.basic_data?.sku}</td>
                <td className={styles.tcTitle}>
                    <Link to={`/katalog/artikal/${item?.product?.id}`} className={styles.productName}>
                        {item?.product?.basic_data?.name}&nbsp;
                        {item?.product?.attributes_text && <>&nbsp;({item?.product?.basic_data?.attributes_text})&nbsp;</>}
                    </Link>
                    {!can_purchase && <div className="text-danger small">{t("cart_checkout-default-text-product_purchase_not_allowed", "Artikal trenutno nije moguće kupiti.")}</div>}
                </td>
                <td className={styles.rebate1}>{formatPrice(item?.product?.price?.per_item?.price_with_out_vat, item?.product?.price?.currency)}</td>
                <td className={styles.rebate2}>{item?.product?.price?.per_item?.rebate?.active ? rabateCalc(item) : "/"}</td>
                <td className={styles.rebate2}>
                    {item?.product?.price?.per_item?.discount?.active ? "-" + currencyFormat(item?.product?.price?.per_item?.discount?.amount, item?.product?.price?.currency) : "/"}
                </td>
                <Tooltip
                    placement={"top"}
                    arrow={true}
                    title={
                        price_visible && (
                            <Box>
                                <Box>
                                    Regularna cena: <span>{currencyFormat(item?.product?.price?.per_item?.price_with_out_vat)}</span>
                                </Box>
                                {item?.product?.price?.per_item?.rebate?.active &&
                                    item?.product?.price?.per_item?.rebate?.rebates?.map((rebate) => {
                                        return (
                                            <Box key={item?.product?.id}>
                                                Cena sa rabatom ({rebate?.calc?.calc_name}): <span>{currencyFormat(rebate?.calc?.price)}</span>
                                            </Box>
                                        );
                                    })}
                                {item?.product?.price?.per_item?.discount?.active &&
                                    item?.product?.price?.per_item?.discount?.campaigns?.map((campaign) => {
                                        return (
                                            <Box key={item?.product?.id}>
                                                Cena sa popustom ({campaign?.calc?.calc_name}): <span>{currencyFormat(campaign?.calc?.price)}</span>
                                            </Box>
                                        );
                                    })}
                            </Box>
                        )
                    }
                >
                    <td
                        className={`${styles.tcPrice} ${item?.product?.price?.per_item?.discount?.active ? styles.discounted : ""} ${
                            item?.product?.price?.per_item?.rebate?.active ? styles.rebateStyle : ""
                        }  ${item?.product?.price?.per_item?.discount?.active && item?.product?.price?.per_item?.rebate?.active ? styles.discountRabate : ""}`}
                    >
                        {formatPrice(item?.product?.price?.per_item?.price_subtotal, item?.product?.price?.currency)}
                    </td>
                </Tooltip>

                <td className={styles.tcInt}>
                    <div className={location.pathname === "/korpa/potvrda" ? styles.plusminus : styles.plusminus1}>
                        {can_purchase ? (
                            <PlusMinusInput
                                key={item?.product?.id + "_web"}
                                behaviours={item?.product?.behaviours?.checkout}
                                max={Number(max)}
                                quantity={Number(item?.cart?.quantity ?? 0)}
                                setQuantity={setQuantity}
                                debounceId={item?.product?.id + "_web"}
                            />
                        ) : (
                            Number(item?.cart?.quantity ?? 0)
                        )}
                    </div>
                </td>
                <td className={styles.tcPrice2}>{formatPrice(item?.product?.price?.cost?.subtotal, item?.product?.price?.currency)}</td>
                <td className={styles.tcActions}>
                    <i
                        style={{ cursor: "pointer" }}
                        className="fa fa-trash"
                        onClick={() => {
                            setShowDialog(true);
                        }}
                    />
                </td>
                {loadingDelete && <div className={styles.loading}></div>}
            </tr>
            <DeleteDialog
                title={"global-header-cart-delete_dialog-title"}
                description={"global-header-cart-delete_dialog-description"}
                openDeleteDialog={{ show: showDialog }}
                setOpenDeleteDialog={() => setShowDialog(false)}
                handleConfirm={() => {
                    setLoadingDelete(true);
                    api.globalRemoveFromCheckout(item?.cart?.cart_item_id, loading, setLoading, loadingDelete, setLoadingDelete);
                    setShowDialog(false);
                }}
            />
        </>
    );
};

export default ProductRow;
